import { ManufacturerProductPropertyOptionDetail } from '@deltek/specification-client/core/Models/product'
import { PropertyType, SupportedOptionsObject } from '../../ListingDetailsPage'

type setPPlusItemsAction = {
    type: 'SET_PPLUS_ITEMS'
    payload: {
        pPlusItems: Record<
            string,
            Record<
                string,
                Record<string, Array<ManufacturerProductPropertyOptionDetail>>
            >
        >
        groupId: string
    }
}

type setSelectedOptionsAction = {
    type: 'SET_SELECTED_OPTIONS'
    payload: SupportedOptionsObject
}

type setDefaultPropertiesAction = {
    type: 'SET_DEFAULT_PROPERTIES'
    payload: Record<string, PropertyType>
}

export type MSAction =
    | setPPlusItemsAction
    | setSelectedOptionsAction
    | setDefaultPropertiesAction

type batchMSAction = { type: 'BATCH_MS_ACTIONS'; payload: Array<MSAction> }

export const MS_ACTIONS = {
    setPPlusItems: 'SET_PPLUS_ITEMS',
    setSelectedOptions: 'SET_SELECTED_OPTIONS',
    setDefaultProperties: 'SET_DEFAULT_PROPERTIES',
    batchMSActions: 'BATCH_MS_ACTIONS',
}

export const DEFAULT_MS_STATE = {
    properties: {},
    selectedOptions: {},
    pPlusItems: {},
}

export type MSState = typeof DEFAULT_MS_STATE
export const setPPlusItemsReducer = (state: MSState, action: MSAction) => ({
    ...state,
    pPlusItems: { ...action.payload },
})

export const setSelectedOptionsReducer = (
    state: MSState,
    action: MSAction
) => ({
    ...state,
    selectedOptions: { ...action.payload },
})

export const setDefaultPropertiesReducer = (
    state: MSState,
    action: MSAction
) => ({
    ...state,
    properties: action.payload,
})

export const msReducerObject = {
    SET_PPLUS_ITEMS: setPPlusItemsReducer,
    SET_SELECTED_OPTIONS: setSelectedOptionsReducer,
    SET_DEFAULT_PROPERTIES: setDefaultPropertiesReducer,
}

const batchMSReducer = (state: MSState, action: batchMSAction) => {
    let tempState = { ...state }
    action.payload.forEach((reducer) => {
        if (msReducerObject[reducer.type]) {
            tempState = msReducerObject[reducer.type](tempState, reducer)
        }
    })

    return tempState
}

export const msReducer = (
    state: MSState = DEFAULT_MS_STATE,
    action: MSAction | batchMSAction
) => {
    if (action.type === 'BATCH_MS_ACTIONS') {
        return batchMSReducer(state, action as batchMSAction)
    } else if (!!msReducerObject[(action as MSAction).type]) {
        return msReducerObject[(action as MSAction).type](
            state,
            action as MSAction
        )
    }
    return state
}
